/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_All_CriteriaInputs */

const en_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Criteria`)
};

const de_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Kriterien`)
};

const fr_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les critères`)
};

const es_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los criterios`)
};

const it_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i criteri`)
};

const nl_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle criteria`)
};

const pl_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie kryteria`)
};

const fi_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki kriteerit`)
};

const da_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle kriterier`)
};

const sv_jobs_all_criteria = /** @type {(inputs: Jobs_All_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla kriterier`)
};

/**
* | output |
* | --- |
* | "All Criteria" |
*
* @param {Jobs_All_CriteriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_all_criteria = /** @type {((inputs?: Jobs_All_CriteriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_All_CriteriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_all_criteria(inputs)
	if (locale === "fr") return fr_jobs_all_criteria(inputs)
	if (locale === "es") return es_jobs_all_criteria(inputs)
	if (locale === "it") return it_jobs_all_criteria(inputs)
	if (locale === "nl") return nl_jobs_all_criteria(inputs)
	if (locale === "pl") return pl_jobs_all_criteria(inputs)
	if (locale === "fi") return fi_jobs_all_criteria(inputs)
	if (locale === "da") return da_jobs_all_criteria(inputs)
	if (locale === "sv") return sv_jobs_all_criteria(inputs)
	return en_jobs_all_criteria(inputs)
});